import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input } from "antd";
import { LockOutlined, MobileOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import ForgetPassword from "./forgetPassword";

function Login({onForgetPass}) {
  const [error, setError] = useState("");
  const [forgetPass, setForgetPass] = useState(false);
  const navigate = useNavigate();
  const LOGIN = gql`
    mutation Login($authLoginInput: AuthLoginInput!) {
      authLogin(authLoginInput: $authLoginInput) {
        accessToken
        expiresAt
        refreshToken
        userRole
      }
    }
  `;
const mobileInput = useRef();
useEffect(() =>{
  mobileInput.current?.focus();
})
  const [runLogin, login] = useMutation(LOGIN, {
    onCompleted(data) {
      const userRole = data?.authLogin.userRole;
      localStorage.setItem("accessToken", data?.authLogin.accessToken);
      localStorage.setItem("expiresAt", data?.authLogin.expiresAt);
      localStorage.setItem("refreshToken", data?.authLogin.refreshToken);
      localStorage.setItem("role", data?.authLogin?.userRole);
      userRole === "ADMIN"
        ? navigate("/admin-dashboard")
        : navigate("/dashboard");
    },
    onError(error) {
      setError(error.message);
    },
  });
  const doLogin = (authLoginInput) => {
    runLogin({
      variables: {
        authLoginInput,
      },
    });
  };
  if(!forgetPass)
  return (
    <div>
      <Form name="normal_login" className="login-form" onFinish={doLogin} onValuesChange={() => setError("")}>
        <Form.Item
          name="mobile"
          style={{ marginBottom: "30px", width:"100%" }}
          rules={[
            {
              required: true,
              message: "لطفا شماره همراه خود را وارد کنید!",
            },
            {
              pattern: /^09[0-9]{9}$/,
              message: "فرمت موبایل صحیح نیست!"
            }
          ]}
          validateStatus={error ? "error" : undefined}
        >
          <Input
            size="large"
            className="form-input"
            prefix={<MobileOutlined className="site-form-item-icon" />}
            placeholder="شماره همراه"
            ref={mobileInput}
          />
        </Form.Item>

        <Form.Item
          name="password"
          style={{ marginBottom: "30px" }}
          rules={[
            {
              required: true,
              message: "لطفا رمز عبور خود را وارد کنید!",
            },
          ]}
          validateStatus={error ? "error" : undefined}
          help={error || undefined}
        >
          <Input.Password
            className="form-input"
            size="large"
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="رمز عبور"
          />
        </Form.Item>

        <Form.Item>
    
          <a className="login-form-forgot" onClick={()=> {setForgetPass(true); onForgetPass(false);}}>
            فراموشی رمز عبور
          </a>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            style={{
              width:"50%",
              display:'block',
              margin:'auto',
              height: '40px'
            }}
            loading={login.loading && true}
          >
            ورود
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
  return <ForgetPassword back={() => {setForgetPass(false); onForgetPass(false);}}/>
}

export default Login;
